<template>
  <nav
    class="
      dark:bg-ant-dark
      relative
      z-50
      flex
      flex-wrap
      items-center
      justify-between
      bg-white
      py-2
      shadow-xl
      md:fixed
      md:inset-y-0
      md:left-0
      md:flex
      md:h-dvh
      md:max-h-dvh
      md:w-64
      md:flex-col
      md:flex-nowrap
      md:overflow-hidden
    "
  >
    <div
      class="
        mx-auto
        flex
        w-full
        flex-wrap
        items-center
        justify-between
        px-6
        md:flex-col
        md:flex-nowrap
        md:shrink-0
        md:items-stretch
      "
    >
      <!-- Toggler -->
      <button
        class="
          rounded-lg
          border
          border-solid
          border-transparent
          bg-transparent
          px-3
          py-1
          text-xl
          leading-none
          text-black
          opacity-50
          md:hidden
        "
        type="button"
        @click="toggleCollapseShow('bg-white m-2 py-3')"
      >
        <i class="fa-solid fa-bars dark:text-slate-300" />
      </button>
      <!-- Brand -->
      <router-link
        v-if="(logo || (darklogo && darkMode)) && userMode == 'team'"
        class="
          hover:text-primary
          mr-0
          inline-block
          whitespace-nowrap
          p-2
          px-0
          text-left
          text-lg
          font-semibold
          text-slate-600
          md:block
          md:pb-2
        "
        to="/app/dashboard"
        :aria-label="`${teamSwitcherLabel} dashboard`"
      >
        <img
          class="h-12"
          :src="(darklogo && darkMode) ? darklogo : logo"
          alt=""
        >
      </router-link>
      <router-link
        v-else-if="!whitelabel || userMode != 'team'"
        class="
          hover:text-primary
          mr-0
          inline-block
          whitespace-nowrap
          p-4
          px-0
          text-left
          text-lg
          font-semibold
          text-slate-600
          dark:text-slate-200
          md:block
          md:pb-2
          lowercase
        "
        to="/app/dashboard"
        style="font-family: 'Montserrat Alternates', sans-serif;"
      >
        Rack Manage
      </router-link>
      <!-- User -->
      <ul class="m-0 flex list-none flex-wrap items-center md:hidden">
        <li class="relative inline-block">
          <user-dropdown />
        </li>
      </ul>
      <!-- Collapse -->
      <div
        :class="collapseShow"
        class="
          dark:bg-ant-dark
          absolute
          inset-x-0
          top-0
          z-40
          h-auto
          flex-1
          items-center
          overflow-y-auto
          overflow-x-hidden
          rounded-lg
          shadow
          md:relative
          md:mt-4
          md:flex
          md:flex-col
          md:items-stretch
          md:opacity-100
          md:shadow-none
        "
      >
        <!-- Collapse header -->
        <div
          class="mb-4 block border-b border-solid border-slate-200 px-4 pb-2 md:hidden md:min-w-full"
        >
          <div
            class="flex flex-wrap"
          >
            <div class="w-6/12">
              <router-link
                v-if="(logo || (darklogo && darkMode)) && userMode == 'team'"
                class="
                  hover:text-primary
                  mr-0
                  inline-block
                  whitespace-nowrap
                  p-2
                  px-0
                  text-left
                  text-lg
                  font-semibold
                  text-slate-600
                  md:block
                  md:pb-2
                "
                to="/app/dashboard"
                :aria-label="`${teamSwitcherLabel} dashboard`"
              >
                <img
                  class="h-12"
                  :src="(darklogo && darkMode) ? darklogo : logo"
                  alt=""
                >
              </router-link>
              <router-link
                v-else-if="!whitelabel || userMode != 'team'"
                class="
                  hover:text-primary
                  mr-0
                  inline-block
                  whitespace-nowrap
                  p-4
                  px-0
                  text-left
                  text-lg
                  font-semibold
                  text-slate-600
                  dark:text-slate-200
                  md:block
                  md:pb-2
                  lowercase
                "
                to="/app/dashboard"
                style="font-family: 'Montserrat Alternates', sans-serif;"
              >
                Rack Manage
              </router-link>
            </div>
            <!-- If we're in whitelabel mode and don't have a logo, stretch to full width -->
            <div
              :class="(whitelabel && userMode == 'team' && !(logo || (darklogo && darkMode)))
                ? 'w-full'
                : 'flex w-6/12 justify-end'
              "
            >
              <button
                type="button"
                class="
                  rounded-lg
                  border
                  border-solid
                  border-transparent
                  bg-transparent
                  px-3
                  py-1
                  text-xl
                  leading-none
                  text-black
                  opacity-50
                  md:hidden
                "
                @click="toggleCollapseShow('hidden')"
              >
                <i class="fa-solid fa-xmark dark:text-slate-300" />
              </button>
            </div>
          </div>
        </div>
        <!-- Form -->
        <form
          class="mb-4 mt-6 px-4 md:hidden"
          @submit.prevent="goToResultsPage"
        >
          <div class="mb-3 pt-0">
            <a-input
              v-model:value="query"
              placeholder="Search here..."
              size="large"
              class="rounded-lg"
            />
          </div>
        </form>
        <a-menu
          mode="inline"
          class="block md:hidden"
          :selected-keys="[openLink]"
        >
          <template
            v-for="item in menuItems"
            :key="item.key"
          >
            <a-menu-item
              v-if="item.type === 'item'"
              :key="item.key"
              :label="item.label"
              :icon="item.icon"
            >
              <a
                :href="item.key"
                @click="handleMenuClick(item.key, $event)"
              >
                {{ item.label }}
              </a>
            </a-menu-item>
            <a-menu-divider
              v-else-if="item.type === 'divider'"
            />
          </template>
        </a-menu>
        <!-- Team switcher (mobile) -->
        <div
          v-if="store.userTeams.length >= 1"
          class="block px-4 py-3 md:hidden"
        >
          <label class="mb-1 block text-xs font-medium text-slate-500 dark:text-slate-400">
            Workspace
          </label>
          <a-dropdown
            :trigger="['click']"
            placement="top"
            class="w-full"
          >
            <button
              type="button"
              class="flex w-full items-center justify-between gap-2 rounded-lg border
                border-slate-200 bg-white px-3 py-2 text-left text-sm
                dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200"
            >
              <span class="min-w-0 truncate">{{ teamSwitcherLabel }}</span>
              <i class="fa-solid fa-chevron-down shrink-0 text-xs text-slate-400" />
            </button>
            <template #overlay>
              <a-menu
                class="min-w-48 rounded-lg"
                :selected-keys="[teamSwitcherValue]"
              >
                <a-menu-item
                  v-for="opt in teamSwitcherOptions"
                  :key="opt.value"
                  @click="onTeamSwitcherChange(opt.value)"
                >
                  {{ opt.label }}
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
    </div>
    <a-menu
      mode="inline"
      class="hidden flex-1 min-h-0 overflow-y-auto md:block"
      :selected-keys="[openLink]"
    >
      <template
        v-for="item in menuItems"
        :key="item.key"
      >
        <a-menu-item
          v-if="item.type === 'item'"
          :key="item.key"
          :label="item.label"
          :icon="item.icon"
        >
          <a
            :href="item.key"
            @click="handleMenuClick(item.key, $event)"
          >
            {{ item.label }}
          </a>
        </a-menu-item>
        <a-menu-divider
          v-else-if="item.type === 'divider'"
        />
      </template>
    </a-menu>
    <!-- Team switcher (desktop) -->
    <div
      v-if="store.userTeams.length >= 1"
      ref="teamSwitcherTourRef"
      class="hidden shrink-0 p-2 px-4 md:block w-full"
    >
      <a-dropdown
        :trigger="['click']"
        placement="topRight"
        class="w-full"
      >
        <a-button
          size="large"
          type="text"
          class="flex! items-center justify-between w-full py-2! px-1.5! min-h-12"
        >
          <div class="flex items-center gap-2">
            <div
              class="size-8 rounded-lg text-white flex items-center justify-center"
              :class="teamSwitcherValue === 'user' ? 'bg-[#10b981]' : 'bg-primary'"
            >
              <i
                v-if="teamSwitcherValue === 'user'"
                class="fa-regular fa-user fa-sm"
              />
              <i
                v-else
                class="fa-solid fa-building fa-sm"
              />
            </div>
            <span class="min-w-0 truncate text-sm font-medium">{{ teamSwitcherLabel }}</span>
          </div>
          <div class="flex flex-col gap-0">
            <i class="fa-solid fa-chevron-up fa-fw relative fa-xs pb-[7px]" />
            <i class="fa-solid fa-chevron-down fa-fw relative fa-xs" />
          </div>
        </a-button>
        <template #overlay>
          <a-menu
            class="min-w-48 rounded-lg"
            :selected-keys="[teamSwitcherValue]"
          >
            <a-menu-item
              v-for="(opt, index) in teamSwitcherOptions"
              :key="opt.value"
              style="padding: 8px 8px; font-size: 14px; font-weight: 500;"
              :class="index !== teamSwitcherOptions.length - 1 ? 'mb-1!' : ''"
              @click="onTeamSwitcherChange(opt.value)"
            >
              <div class="flex items-center gap-2">
                <div
                  :style="
                    `--team-color: ${
                      teamSwitcherOptions.find(o => o.value === opt.value)?.color ?? '#10b981'
                    }`"
                  class="size-8 rounded-lg text-white flex items-center justify-center"
                  :class="opt.value === 'user' ?
                    'bg-[#10b981]' :
                    `bg-(--team-color)`
                  "
                >
                  <i
                    v-if="opt.value === 'user'"
                    class="fa-regular fa-user fa-sm"
                  />
                  <i
                    v-else
                    class="fa-solid fa-building fa-sm"
                  />
                </div>
                {{ opt.label }}
              </div>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
    <a-tour
      v-model:current="teamSwitcherTourCurrent"
      :open="teamSwitcherTourOpen"
      :steps="teamSwitcherTourSteps"
      @close="onTeamSwitcherTourClose"
      @finish="onTeamSwitcherTourClose"
    />
  </nav>
</template>

<script setup lang="ts">
import UserDropdown from '../Dropdowns/UserDropdown.vue';
import { useStore } from '../../api/index.ts';
import { storeToRefs } from 'pinia';
import { h, ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import type { TourProps } from 'ant-design-vue';
import {
  LayoutFilled,
  SettingFilled,
  HddFilled,
  EnvironmentFilled,
  PictureFilled,
  UserOutlined,
  AreaChartOutlined,
  LikeFilled,
  BarsOutlined,
  TeamOutlined,
  // TeamOutlined,
  // SafetyCertificateFilled,
  // CloudFilled,
  // LockFilled,
  // DollarCircleFilled,
} from '@ant-design/icons-vue';
import { usePostHog } from '../../composables/usePosthog.ts';

const store = useStore();
const router = useRouter();
const { posthog } = usePostHog();

const logo = ref('');
const darklogo = ref('');
const subscription = ref('Free');

onMounted(() => {
  store.currentSubscription().then((sub: string) => {
    subscription.value = sub;
  });
});

const administrator = computed(() => {
  return store.system.permissions && store.system.permissions.includes('administrator');
});

const moderator = computed(() => {
  return store.system.permissions && store.system.permissions.includes('moderator');
});

if (store.checkedDomain && store.checkedDomain.data && store.checkedDomain.data.logo) {
  logo.value = import.meta.env.VITE_CDN_URL + store.checkedDomain.data.logo;
} else if (store.teamData && store.teamData.logo) {
  logo.value = import.meta.env.VITE_CDN_URL + store.teamData.logo;
}

if (store.checkedDomain && store.checkedDomain.data && store.checkedDomain.data.darklogo) {
  darklogo.value = import.meta.env.VITE_CDN_URL + store.checkedDomain.data.darklogo;
} else if (store.teamData && store.teamData.logodark) {
  darklogo.value = import.meta.env.VITE_CDN_URL + store.teamData.logodark;
}

const defaultItems = computed(() => {
  const items = [
    {
      key: '/app/dashboard',
      icon: () => h(LayoutFilled),
      label: 'Dashboard',
      type: 'item',
    },
    {
      key: '/app/racks',
      icon: () => h(HddFilled),
      label: 'Racks',
      type: 'item',
    },
    {
      key: '/app/rooms',
      icon: () => h(EnvironmentFilled),
      label: 'Rooms',
      type: 'item',
    },
    {
      key: '/app/types',
      icon: () => h(PictureFilled),
      label: 'Slot Types',
      type: 'item',
    },
  ];

  // If inventory is enabled, add it to the dashboard
  if (subscription.value == 'Plus') {
    items.push({
      key: '/app/inventory',
      icon: () => h(BarsOutlined),
      label: 'Inventory',
      type: 'item',
    });
  } else if (posthog && typeof posthog.isFeatureEnabled === 'function') {
    const isInventoryEnabled = posthog.isFeatureEnabled('inventory');
    if (isInventoryEnabled) {
      items.push({
        key: '/app/inventory',
        icon: () => h(BarsOutlined),
        label: 'Inventory',
        type: 'item',
      });
    }
  }

  items.push({
    key: '/app/settings',
    icon: () => h(SettingFilled),
    label: 'Settings',
    type: 'item',
  });

  return items;
});

const adminItems = [
  { key: 'divider1', type: 'divider' },
  {
    key: '/admin/dashboard',
    icon: () => h(AreaChartOutlined),
    label: 'Admin Dashboard',
    type: 'item',
  },
  {
    key: '/admin/users',
    icon: () => h(UserOutlined),
    label: 'User Admin',
    type: 'item',
  },
  {
    key: '/admin/teams',
    icon: () => h(TeamOutlined),
    label: 'Team Admin',
    type: 'item',
  },
  // { key: '2', icon: h(TeamOutlined), label: 'Teams', type: 'item', to: '/admin/teams' },
  // { key: '3', icon: h(SafetyCertificateFilled), label: 'Permissions', type: 'item', to: '/admin/permissions' },
  // { key: '4', icon: h(CloudFilled), label: 'Infrastructure', type: 'item', to: '/admin/infrastructure' },
  // { key: '5', icon: h(LockFilled), label: 'Authentication', type: 'item', to: '/admin/authentication' },
  // { key: '8', icon: h(DollarCircleFilled), label: 'Billing', type: 'item', to: '/admin/billing' },
];

const moderatorItems = [
  { key: 'divider2', type: 'divider' },
  {
    key: '/admin/moderation',
    icon: () => h(LikeFilled),
    label: 'Moderation',
    type: 'item',
  },
  {
    key: '/admin/types',
    icon: () => h(PictureFilled),
    label: 'Global Slot Types',
    type: 'item',
  },
];

const { userPreferences } = storeToRefs(store);

const collapseShow = ref('hidden');
const whitelabel = computed(() => (
  store.checkedDomain != null
  && store.checkedDomain.data
  && !store.checkedDomain.domain.endsWith(import.meta.env.VITE_HOSTNAME)
  && store.userMode != 'user'
));
const darkMode = ref(userPreferences.value.darkMode);
const query = ref('');
const openLink = ref(router.currentRoute.value.path);
const userMode = computed(() => store.userMode);

// Team switcher: only show when user has at least one team
const teamSwitcherValue = computed(() => (
  userMode.value === 'user' ? 'user' : (store.team ?? 'user')
));
const teamSwitcherOptions = computed(() => {
  const options: { value: string; label: string; color: string | null }[] = [
    { value: 'user', label: 'Personal Workspace', color: null },
  ];
  for (const t of store.userTeams) {
    if (t.color) {
      const hexColor = '#' + (1 << 24 | t.color.red << 16 | t.color.green << 8 | t.color.blue).toString(16).slice(1);
      options.push({ value: t.id, label: t.name, color: hexColor });
    } else {
      options.push({ value: t.id, label: t.name, color: null });
    }
  }
  return options;
});
const teamSwitcherLabel = computed(() => {
  const opt = teamSwitcherOptions.value.find(o => o.value === teamSwitcherValue.value);
  return opt?.label ?? 'Personal Workspace';
});

// Tour: show once to users who had the legacy .team field (flag stored in user doc, syncs globally)
// Only show on desktop (md+) where the team switcher is visible
const teamSwitcherTourRef = ref<HTMLElement | null>(null);
const teamSwitcherTourOpen = ref(false);
const teamSwitcherTourCurrent = ref(0);
const teamSwitcherTourCheckDone = ref(false);
const isDesktopViewport = ref(typeof window !== 'undefined' && window.matchMedia('(min-width: 768px)').matches);
const teamSwitcherTourSteps: TourProps['steps'] = [
  {
    title: 'Workspace Switcher',
    description: 'You can now join multiple teams. Use this menu to switch between your Personal Workspace and any teams.',
    target: () => teamSwitcherTourRef.value as HTMLElement,
    placement: 'topRight',
  },
];

async function onTeamSwitcherTourClose() {
  teamSwitcherTourOpen.value = false;
  try {
    await store.setTeamSwitcherTourShown();
  } catch {
    // still close the tour; preference will sync on next success
  }
}

async function tryShowTeamSwitcherTour() {
  if (teamSwitcherTourCheckDone.value || store.userTeams.length < 1) return;
  if (!isDesktopViewport.value) return; // don't show on mobile; switcher is hidden there
  teamSwitcherTourCheckDone.value = true;
  try {
    const { hasLegacyTeam, tourShown } = await store.getUserDocTeamSwitcherTourFlags();
    if (tourShown || !hasLegacyTeam) return;
    await nextTick();
    teamSwitcherTourCurrent.value = 0;
    teamSwitcherTourOpen.value = true;
  } catch {
    // don't block the app if check fails
  }
}

watch(() => store.userTeams.length, () => tryShowTeamSwitcherTour(), { immediate: true });
watch(isDesktopViewport, (desktop) => { if (desktop) tryShowTeamSwitcherTour(); });
onMounted(() => {
  tryShowTeamSwitcherTour();
  const mql = window.matchMedia('(min-width: 768px)');
  const update = () => { isDesktopViewport.value = mql.matches; };
  mql.addEventListener('change', update);
  onUnmounted(() => mql.removeEventListener('change', update));
});

async function onTeamSwitcherChange(value: string) {
  const toOption = teamSwitcherOptions.value.find(o => o.value === value);
  if (!toOption) return;
  await store.switchWorkspaceWithPopup(toOption);
}

// Computed property for menu items that combines all items
const menuItems = computed(() => {
  if (moderator.value || administrator.value) {
    if (administrator.value) {
      return [...defaultItems.value, ...adminItems, ...moderatorItems];
    }
    return [...defaultItems.value, ...moderatorItems];
  }
  return defaultItems.value;
});

watch(userPreferences.value, (val) => {
  darkMode.value = val.darkMode;
}, { deep: true },
);

watch(() => router.currentRoute.value.path, () => {
  openLink.value = router.currentRoute.value.path;
}, { immediate: true },
);

function toggleCollapseShow(classes: string) {
  collapseShow.value = classes;
}
function goToResultsPage() {
  router.push({ path: '/app/search', query: { query: query.value } });
  collapseShow.value = 'hidden';
}
function handleMenuClick(path: string, event: MouseEvent) {
  // Allow native browser behavior for ctrl+click, middle-click, right-click, etc.
  const isModifierClick = event.ctrlKey || event.metaKey || event.shiftKey;
  const isMiddleClick = event.button === 1;
  const isRightClick = event.button === 2;

  if (isModifierClick || isMiddleClick || isRightClick) {
    // Let the browser handle it naturally via href
    // Don't prevent default or stop propagation for these cases
    return;
  }

  // For normal left clicks, prevent default and use Vue Router
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation(); // Also stop immediate propagation to be safe

  // Hide the mobile collapse menu
  collapseShow.value = 'hidden';

  // Only navigate if we're not already on that route
  const currentPath = router.currentRoute.value.fullPath;
  if (currentPath !== path) {
    router.push(path).catch((err) => {
      // Ignore navigation errors (e.g., navigating to the same route)
      if (err.name !== 'NavigationDuplicated') {
        console.error('Navigation error:', err);
      }
    });
  }
}
</script>

<style scoped>
.ant-menu-root {
  border-inline-end: none !important;
}
</style>
